import api from '../utils/api'

export function getSaldos () {
  return api.get('saldos')
}
